module.exports = {
  corruptFileDetected: 'Please make sure that the file does not come from inside a zip archive and that it is not corrupted.',
  deleteFile: 'An error occurred during deletion',
  dragItemsHere: 'Drag item here',
  or: 'or',
  fileInformationUnavailable: 'File information not available',
  fileLoadError: 'An error occurred during loading',
  fileTypeUnsupported: 'This file type is not supported',
  invalidFile: 'Invalid file selected',
  loading: 'Loading',
  browseFile: 'Browse file',
  uploadCancelled: 'Upload cancelled',
  uploadCancelledError: 'An error occurred during cancellation',
  uploadFailed: 'An error occurred during upload',
  upToMB: 'Up to {size}MB',
  waitForFileInformation: 'Wait for file information',
}
